"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWidth = exports.ButtonWidth = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var Input_1 = __importDefault(require("./Input"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var rgba_1 = __importDefault(require("polished/lib/color/rgba"));

var enums_1 = require("./enums");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_common_1 = require("@ryerson/frontend.common");

var ButtonWidth;

(function (ButtonWidth) {
  ButtonWidth["sm"] = "15px";
  ButtonWidth["md"] = "20px";
  ButtonWidth["lg"] = "30px";
  ButtonWidth["xl"] = "40px";
})(ButtonWidth || (exports.ButtonWidth = ButtonWidth = {}));

var IconWidth;

(function (IconWidth) {
  IconWidth["sm"] = "5px";
  IconWidth["md"] = "7px";
  IconWidth["lg"] = "10px";
  IconWidth["xl"] = "10px";
})(IconWidth || (exports.IconWidth = IconWidth = {}));

var chevronDownSvg = 'data:image/svg+xml;utf-8,<svg width="10" height="11.42" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path style="fill: lightGrey" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>';
var IconContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\theight: 100%;\n\twidth: 100%;\n\talign-items: center;\n\tjustify-content: center;\n\t", "\n"])), function (props) {
  var size = props.size,
      mobile = props.mobile;
  return mobile ? "" : (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\tbackground: url(", ") center /\n\t\t\t\t\t\t", " no-repeat #ffffff00;\n\t\t\t  "])), "'".concat(chevronDownSvg, "'"), IconWidth[size]);
});
var up = (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\ttransform: rotate(180deg);\n"])));
var ControlContainer = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tposition: relative;\n\toverflow: hidden;\n\tpadding: 0;\n\tvertical-align: middle;\n"])));
var SpinButton = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\theight: 50%;\n\ttop: 0;\n\tright: 0;\n\tmargin: 0;\n\tborder: none;\n\tbackground: none;\n\t", "\n"])), function (props) {
  var theme = props.theme,
      disabled = props.disabled,
      size = props.size;
  return (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\tpadding: ", ";\n\t\t\twidth: ", ";\n\t\t\tcursor: ", ";\n\t\t\tborder-left: 1px solid ", ";\n\t\t\t&:last-child {\n\t\t\t\tborder-top: 1px solid ", ";\n\t\t\t\tbottom: 0;\n\t\t\t\ttop: 50%;\n\t\t\t}\n\t\t"])), size === "sm" ? "0 1px 0 0" : "0", ButtonWidth[size], disabled ? "default" : "pointer", (0, rgba_1.default)(theme.colors.primary.darkGray, 0.1), (0, rgba_1.default)(theme.colors.primary.darkGray, 0.1));
});
var DecrementButton = styled_1.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tz-index: 1;\n\tposition: absolute;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tpadding: 0;\n\tmargin: 0;\n\tborder: none;\n\tbackground: none;\n\t", "\n"])), function (props) {
  var theme = props.theme,
      disabled = props.disabled,
      size = props.size,
      _props$mobile = props.mobile,
      mobile = _props$mobile === void 0 ? false : _props$mobile;
  return (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\twidth: ", ";\n\t\t\tcursor: ", ";\n\t\t\tborder-right: 1px solid ", ";\n\t\t"])), mobile ? "50px" : ButtonWidth[size], disabled ? "default" : "pointer", (0, rgba_1.default)(theme.colors.primary.darkGray, 0.1));
});
var IncrementButton = styled_1.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\tz-index: 1;\n\tposition: absolute;\n\theight: 100%;\n\ttop: 0;\n\tright: 0;\n\tpadding: 0;\n\tmargin: 0;\n\tborder: none;\n\tbackground: none;\n\t", "\n"])), function (props) {
  var theme = props.theme,
      disabled = props.disabled,
      size = props.size,
      _props$mobile2 = props.mobile,
      mobile = _props$mobile2 === void 0 ? false : _props$mobile2;
  return (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\twidth: ", ";\n\t\t\tcursor: ", ";\n\t\t\tborder-left: 1px solid ", ";\n\t\t"])), mobile ? "50px" : ButtonWidth[size], disabled ? "default" : "pointer", (0, rgba_1.default)(theme.colors.primary.darkGray, 0.1));
});
var Label = styled_1.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t", "\n"])), function (props) {
  var theme = props.theme,
      disabled = props.disabled,
      type = props.type,
      size = props.size;
  var _theme$colors$primary = theme.colors.primary,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      disable = _theme$colors$primary.disable;
  return (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\tfont-size: ", ";\n\t\t\tcolor: ", ";\n\t\t\tmargin-bottom: ", ";\n\t\t"])), theme.typography.fonts.sizes.md.size, disabled ? disable : type === "tertiary" ? disable : secondaryBrand, enums_1.LabelBottomMargin[size]);
});

var IncrementDecrementInput = function IncrementDecrementInput(_ref) {
  var id = _ref.id,
      className = _ref.className,
      value = _ref.value,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      dataTestId = _ref.dataTestId,
      onIncrement = _ref.onIncrement,
      onDecrement = _ref.onDecrement,
      onChange = _ref.onChange,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      language = _ref.language,
      inputRef = _ref.inputRef,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      sizeMobile = _ref.sizeMobile;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var errorColor = theme.colors.primary.error;

  var _ref3 = (0, frontend_common_1.useWindowSize)(),
      _ref4 = _slicedToArray(_ref3, 1),
      width = _ref4[0];

  sizeMobile && width < parseInt(theme.breakpoints.lg) && (size = sizeMobile);
  return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
    children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Media, {
      lessThan: "lg",
      children: [label && (0, jsx_runtime_1.jsxs)(Label, {
        theme: theme,
        disabled: disabled,
        type: type,
        size: size,
        children: [label, required && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          color: errorColor,
          children: " *"
        })]
      }), (0, jsx_runtime_1.jsxs)(ControlContainer, {
        children: [(0, jsx_runtime_1.jsx)(DecrementButton, {
          theme: theme,
          disabled: disabled,
          type: type,
          size: size,
          mobile: true,
          onClick: function onClick() {
            !disabled && onDecrement();
          },
          "data-testid": dataTestId ? "".concat(dataTestId, "-decrement-btn") : "",
          children: (0, jsx_runtime_1.jsx)(IconContainer, {
            mobile: true,
            children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              children: "-"
            })
          })
        }), (0, jsx_runtime_1.jsx)(Input_1.default, {
          name: name,
          id: id,
          className: className,
          value: value,
          onChange: onChange,
          dataTestId: dataTestId,
          disabled: disabled,
          size: size,
          required: required,
          type: type,
          inputType: "number",
          addStyle: {
            textAlign: "center",
            paddingRight: ButtonWidth[size],
            paddingLeft: ButtonWidth[size],
            MozAppearance: "textfield"
          },
          language: language,
          inputRef: inputRef,
          sizeMobile: sizeMobile
        }), (0, jsx_runtime_1.jsx)(IncrementButton, {
          theme: theme,
          disabled: disabled,
          type: type,
          size: size,
          mobile: true,
          onClick: function onClick() {
            !disabled && onIncrement();
          },
          "data-testid": dataTestId ? "".concat(dataTestId, "-increment-btn") : "",
          children: (0, jsx_runtime_1.jsx)(IconContainer, {
            mobile: true,
            children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              children: "+"
            })
          })
        })]
      })]
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Media, {
      greaterThanOrEqual: "lg",
      children: [label && (0, jsx_runtime_1.jsxs)(Label, {
        theme: theme,
        disabled: disabled,
        type: type,
        size: size,
        children: [label, required && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          color: errorColor,
          children: " *"
        })]
      }), (0, jsx_runtime_1.jsxs)(ControlContainer, {
        children: [(0, jsx_runtime_1.jsx)(Input_1.default, {
          name: name,
          id: id,
          className: className,
          value: value,
          onChange: onChange,
          dataTestId: dataTestId,
          disabled: disabled,
          size: size,
          required: required,
          type: type,
          inputType: "number",
          addStyle: {
            paddingRight: ButtonWidth[size],
            MozAppearance: "textfield"
          },
          language: language,
          inputRef: inputRef
        }), (0, jsx_runtime_1.jsx)(SpinButton, {
          theme: theme,
          disabled: disabled,
          type: type,
          size: size,
          onClick: function onClick() {
            !disabled && onIncrement();
          },
          "data-testid": dataTestId ? "".concat(dataTestId, "-increment-btn") : "",
          children: (0, jsx_runtime_1.jsx)(IconContainer, {
            css: up,
            size: size
          })
        }), (0, jsx_runtime_1.jsx)(SpinButton, {
          theme: theme,
          disabled: disabled,
          type: type,
          size: size,
          onClick: function onClick() {
            !disabled && onDecrement();
          },
          "data-testid": dataTestId ? "".concat(dataTestId, "-decrement-btn") : "",
          children: (0, jsx_runtime_1.jsx)(IconContainer, {
            size: size
          })
        })]
      })]
    })]
  });
};

IncrementDecrementInput.displayName = "IncrementDecrementInput";
exports.default = IncrementDecrementInput;